import LabeledContainer from "./LabeledContainer"
import PillLabel from "./PillLabel"

export default function SerialNumbers({ serialNumbers }) {
   return <LabeledContainer label="Serial numbers" className="rounded-lg p-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
         {
            serialNumbers.map(entry => {
               return <div key={entry.product._id} className="">
                  <b>{entry.product.name}</b>
                  <div className="flex gap-2">
                     {
                        entry.serial_numbers.map(serialNumber => <PillLabel>{serialNumber}</PillLabel>)
                     }
                  </div>
               </div>
            })
         }
      </div>
   </LabeledContainer>
}